import { useNavigate } from 'react-router-dom';
import notificationApi from '../services/notification-api';
import { toast } from 'react-hot-toast';
import { createRoute, PATHS } from '@src/core/router/paths';
import type { TNotification } from '@src/shared/types/notification';

export const useNotificationRead = () => {
  const navigate = useNavigate();
  const { mutateAsync: markAsRead } = notificationApi.useMarkAsRead();
  const { mutateAsync: markAllAsRead } = notificationApi.useMarkAllAsRead();
  const handleRead = async (ids: TNotification['id'][]) => {
    const reqBody = { ids };
    await markAsRead(reqBody);
  };

  const handleAllAsRead = async () => {
    await markAllAsRead({});
    toast.success('Notification marked as readed!');
  };

  const handleNotificationReadAndRedirection = async ({
    id,
    entity_type,
    entity_id,
    data: extraData,
    is_read,
  }: Pick<
    TNotification,
    'id' | 'entity_type' | 'entity_id' | 'data' | 'is_read'
  >) => {
    if (!is_read) handleRead([id]);

    if (!entity_id) return;

    switch (entity_type) {
      case 'TASK':
        navigate(createRoute(`/tasks?id=${entity_id}`));
        break;

      case 'TASK_COMMENT':
        extraData?.task_id
          ? navigate(
              createRoute(
                `/tasks?id=${extraData?.task_id}&commentId=${entity_id}`
              )
            )
          : null;
        break;

      case 'INVOICE':
        navigate(createRoute(`/invoices?id=${entity_id}`));
        break;

      case 'PROGRAM_SUBMISSION':
        navigate(createRoute(PATHS.SINGLE_SUBMISSION(entity_id)));
        break;

      case 'LEAD':
        navigate(createRoute(`/leads/${entity_id}`));
        break;

      case 'PLACEMENT_APPLICATION':
        extraData?.submission_id
          ? navigate(
              createRoute(
                `${PATHS.SINGLE_SUBMISSION(extraData.submission_id)}?tab=placements`
              )
            )
          : null;
        break;

      case 'RECEIPT':
        navigate(
          createRoute(
            `${PATHS.ACCOUNTING_PAYMENTS}?tab=requests&receiptId=${entity_id}`
          )
        );
        break;

      default:
        null;
        break;
    }
  };

  return { handleRead, handleAllAsRead, handleNotificationReadAndRedirection };
};
